const menuList = [
  {
    id: 0,
    name: 'Dashboard',
    icon: 'mdi-view-dashboard',
    link: '/dashboard',
    active: true,
    accessRoleId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 1,
    name: 'Masters',
    icon: 'mdi-domain',
    children: [
      {
        id: 11,
        name: 'Locations',
        icon: 'mdi-map-marker-star',
        link: '/locations',
        active: false,
        accessRoleId: [1, 2],
      },
      {
        id: 12,
        name: 'Branches',
        icon: 'mdi-office-building-marker',
        link: '/branches',
        active: false,
        accessRoleId: [1, 2],
      },
      {
        id: 13,
        name: 'Godowns',
        icon: 'mdi-warehouse',
        link: '/godowns',
        active: false,
        accessRoleId: [1, 2],
      },
      {
        id: 14,
        name: 'Employees',
        icon: 'mdi-badge-account-outline',
        link: '/employees',
        active: false,
        accessRoleId: [1, 2],
      },
      {
        id: 15,
        name: 'Customers',
        icon: 'mdi-briefcase-account',
        link: '/customers',
        active: false,
        accessRoleId: [1, 2],
      },
      {
        id: 16,
        name: 'Content',
        icon: 'mdi-content-paste',
        link: '/content',
        active: false,
        accessRoleId: [1, 2],
      },
      {
        id: 17,
        name: 'Designations',
        icon: 'mdi-card-account-details-outline',
        link: '/designation',
        active: false,
        accessRoleId: [1, 2],
      },
      {
        id: 18,
        name: 'Vehicle',
        icon: 'mdi-truck',
        link: '/vehicles',
        active: false,
        accessRoleId: [1, 2],
      },
      {
        id: 19,
        name: 'Users',
        icon: 'mdi-account-group',
        link: '/users',
        active: false,
        accessRoleId: [1, 2],
      },
    ],
  },
  {
    id: 2,
    name: 'Entries',
    icon: 'mdi-table-large',
    children: [
      {
        id: 21,
        name: 'Memo',
        icon: 'mdi-card-bulleted-outline',
        link: '/memo',
        active: false,
        accessRoleId: [1, 2, 3, 4, 5, 6],
      },
      {
        id: 22,
        name: 'LR',
        icon: 'mdi-archive-arrow-down-outline',
        link: '/lr',
        active: false,
        accessRoleId: [1, 2, 3, 4, 5, 6],
      },
      {
        id: 23,
        name: 'Expense',
        icon: 'mdi-cash-plus',
        link: '/expense',
        active: false,
        accessRoleId: [1, 2, 3, 4, 5, 6],
      },
    ],
  },
  {
    id: 3,
    name: 'Transactions',
    icon: 'mdi-bank-transfer',
    children: [
      {
        id: 31,
        name: 'Freight Receipt Generate',
        icon: 'mdi-cash-sync',
        link: '/freightreceipt',
        accessRoleId: [1, 2, 3, 4, 5, 6],
      },
      {
        id: 32,
        name: 'Freight Payment Update',
        icon: 'mdi-account-cash',
        link: '/freightupdate',
        accessRoleId: [1, 2, 3, 4, 5, 6],
      },
      {
        id: 33,
        name: 'Lr Search',
        icon: 'mdi-text-box-search',
        link: '/lrsearch',
        accessRoleId: [1, 2, 3, 4, 5, 6],
      },
      {
        id: 34,
        name: 'Lr Status Update',
        icon: 'mdi-update',
        link: '/lrstatusupdate',
        accessRoleId: [1, 2, 3],
      },
    ],
  },
  {
    id: 4,
    name: 'Reports',
    icon: 'mdi-gesture-two-tap',
    children: [
      {
        id: 41,
        name: 'Daily Delivery Statement',
        icon: 'mdi-chart-box-outline',
        link: '/reports/dds',
        accessRoleId: [1, 2, 3, 4, 5],
      },
      {
        id: 42,
        name: 'Agent Report',
        icon: 'mdi-face-agent',
        link: '/reports/agentreport',
        accessRoleId: [1, 2, 3, 4, 5],
      },
      {
        id: 43,
        name: 'Pending Goods',
        icon: 'mdi-archive-alert',
        link: '/reports/pendinggoods',
        accessRoleId: [1, 2, 3, 4, 5],
      },
      {
        id: 44,
        name: 'Pending Dues',
        icon: 'mdi-treasure-chest',
        link: '/reports/pendingdues',
        accessRoleId: [1, 2, 3, 4, 5],
      },

      {
        id: 45,
        name: 'Invoice',
        icon: 'mdi-invoice-list-outline',
        link: '/reports/invoices',
        accessRoleId: [1, 2, 3, 4, 5],
      },
    ],
  },
  {
    id: 5,
    name: 'Branch Serial No',
    icon: 'mdi-counter',
    link: '/reports/serialnumber',
    accessRoleId: [1, 2],
  },
];

function getMenuListByRoleId(roleId) {
  return menuList.filter((item) => {
    if (item.children) {
      item.children = item.children.filter((child) =>
        child.accessRoleId.includes(roleId),
      );
      return item.children.length > 0;
    } else {
      return item.accessRoleId.includes(roleId);
    }
  });
}
export { menuList, getMenuListByRoleId };
